webpackJsonp([74],{

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1336);


/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _ja = __webpack_require__(775);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('ja', _ja2.default);

/***/ })

},[1335]);


// WEBPACK FOOTER //
// app/datetime.ja-255fbd106f314c0d5600.js